import { all, takeEvery, put, call, select } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'
import invoice2LineActions from '../invoice2Lines/actions'
import { SAVE_200_MSG, SAVE_200_DESC, DEL_200_MSG, DEL_200_DESC } from '../../constants'
import {
  list,
  find,
  save,
  remove,
  createInvoice,
  createInvoiceByWorkOrderID,
  addWorkOrdersToInvoice,
} from '../../services/invoice2'
import { save as saveInvoice2Line } from '../../services/invoice2Line'

function* fetchInvoice2sRefresh() {
  const fe = JSON.parse(localStorage.getItem('fetchInvoice2s'))
  if (fe == null) {
    fe.size = 10
    fe.index = 0
    fe.searchTerm = ''
    fe.orderBy = ''
  }
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, fe.size, fe.index, fe.searchTerm, fe.orderBy)
  yield put({
    type: actions.LIST_INVOICE2,
    result,
  })
}

function* fetchInvoice2s({ size, index, searchTerm, orderBy }) {
  // Load last params froom last session.
  if (!size && !index && !searchTerm && !orderBy) {
    const fe = JSON.parse(localStorage.getItem('fetchInvoice2s'))
    if (fe != null) {
      size = fe.size || 10
      index = fe.index || 0
      searchTerm = fe.searchTerm || ''
      orderBy = fe.orderBy || ''
    } else {
      size = 10
      index = 0
      searchTerm = ''
      orderBy = ''
    }
  }
  localStorage.setItem('fetchInvoice2s', JSON.stringify({ size, index, searchTerm, orderBy }))
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, size, index, searchTerm, orderBy)
  yield put({
    type: actions.LIST_INVOICE2,
    result,
  })
}

function* fetchInvoice2sSilent({ size, index, searchTerm, orderBy }) {
  // Load last params froom last session.
  if (!size && !index && !searchTerm && !orderBy) {
    const fe = JSON.parse(localStorage.getItem('fetchInvoice2s'))
    if (fe != null) {
      size = fe.size || 10
      index = fe.index || 0
      searchTerm = fe.searchTerm || ''
      orderBy = fe.orderBy || ''
    } else {
      size = 10
      index = 0
      searchTerm = ''
      orderBy = ''
    }
  }
  localStorage.setItem('fetchInvoice2s', JSON.stringify({ size, index, searchTerm, orderBy }))
  const result = yield call(list, size, index, searchTerm, orderBy)
  yield put({
    type: actions.LIST_INVOICE2,
    result,
  })
}

function* fetchInvoice2Edit({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(find, id)
  yield put({
    type: actions.EDIT_INVOICE2,
    result,
  })
}

function* fetchInvoice2Save(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(save, values)
  if (result !== null) {
    if (result.status === 1) {
      notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })

      // Text lines added while the invoice was still unsaved (invoiceID 0) are
      // buffered in invoice2Lines.pendingList - write them now against the
      // freshly created invoiceID (result.value). Only a CREATE may flush;
      // an update of an existing invoice never adopts leftover buffered lines.
      const savedInvoiceID =
        values && values.values ? parseInt(values.values.invoiceID, 10) || 0 : 0
      const pendingLines = yield select(state => state.invoice2Lines.pendingList)
      if (savedInvoiceID === 0 && pendingLines && pendingLines.length > 0 && result.value) {
        for (let i = 0; i < pendingLines.length; i += 1) {
          yield call(saveInvoice2Line, {
            values: { ...pendingLines[i], invoice2LineID: 0, invoiceID: result.value },
          })
        }
        yield put({ type: invoice2LineActions.CLEAR_PENDING_INVOICE2LINES })
      }

      yield put({
        type: actions.SAVE_INVOICE2_RECIEVED,
        result: result.value,
      })
    } else {
      notification.error({ message: 'Error', description: result.message })
      yield put({
        type: actions.RESPONSE_ERROR,
        message: result.value,
      })
    }
    yield put({
      type: actions.RE_FETCH_INVOICE2S,
    })
  }
}

function* fetchAddWorkOrdersToInvoice(values) {
  console.log('fetchAddWorkOrdersToInvoice', values)
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(addWorkOrdersToInvoice, values)
  if (result !== null) {
    if (result.status === 1) {
      notification.success({ message: SAVE_200_MSG, description: result.message })
      yield put({
        type: actions.ADD_WORKORDERS_TO_INVOICE2_RECIEVED,
        result,
      })
    } else {
      notification.error({ message: 'Error', description: result.message })
      yield put({
        type: actions.RESPONSE_ERROR,
        message: result.message,
      })
    }
  }
}

function* fetchInvoice2Delete({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(remove, id)
  if (result !== null) {
    notification.success({ message: DEL_200_MSG, description: DEL_200_DESC })
  }
  yield put({
    type: actions.DELETE_INVOICE2_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_INVOICE2S,
  })
}

function* reds() {
  yield put({
    type: actions.RESET_INVOICE2_rec,
  })
}

function* fetchCreateInvoiceByWorkOrderID({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(createInvoiceByWorkOrderID, id)
  if (result !== null) {
    if (result.status === 1) {
      notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
    } else {
      notification.error({ message: 'Error', description: result.message })
    }
  }
  yield put({
    type: actions.CREATE_INVOICE2_BYWORKORDERID_RECIEVED,
    result: result.value,
  })
}

function* createInvoiceFetch({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(createInvoice, id)
  if (result.status === 0) {
    notification.error({ message: 'Error', description: result.message })
  }
  yield put({
    type: actions.CREATE_INVOICE2_RECIEVED,
    result: result.value,
  })

  const fe = JSON.parse(localStorage.getItem('fetchInvoice2s'))
  if (fe == null) {
    fe.size = 10
    fe.index = 0
    fe.searchTerm = ''
    fe.orderBy = ''
  }
  yield put({
    type: actions.REQUESTING,
  })
  const result2 = yield call(list, fe.size, fe.index, fe.searchTerm, fe.orderBy)
  yield put({
    type: actions.LIST_INVOICE2,
    result: result2,
  })
}

function* resetInvoiceResetFetch() {
  yield put({
    type: actions.CREATE_INVOICE2_RESET,
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_INVOICE2S_SILENT, fetchInvoice2sSilent),
    takeEvery(actions.FETCH_INVOICE2S, fetchInvoice2s),
    takeEvery(actions.CREATE_INVOICE2_BYWORKORDERID, fetchCreateInvoiceByWorkOrderID),
    takeEvery(actions.FETCH_INVOICE2, fetchInvoice2Edit),
    takeEvery(actions.SAVE_INVOICE2, fetchInvoice2Save),
    takeEvery(actions.DELETE_INVOICE2, fetchInvoice2Delete),
    takeEvery(actions.RE_FETCH_INVOICE2S, fetchInvoice2sRefresh),
    takeEvery(actions.RESET_INVOICE2, reds),

    takeEvery(actions.CREATE_INVOICE2, createInvoiceFetch),
    takeEvery(actions.CREATE_INVOICE2_RESET, resetInvoiceResetFetch),

    takeEvery(actions.ADD_WORKORDERS_TO_INVOICE2, fetchAddWorkOrdersToInvoice),
  ])
}
